import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import React from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineLanguage } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import Button from "./Button";

const LanguageSwitcher = ({ isWhite }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const changeLanguage = (lng) => {
    const currentPath = window.location.pathname.split("/");
    currentPath[1] = lng;
    navigate(currentPath.join("/"));
  };

  const lang = window.location.pathname.split("/")[1];

  return (
    <div className="relative">
      <Menu
        menuButton={
          <MenuButton className="flex items-center justify-center rounded-md transition-colors hover:bg-gray-50 dark:hover:bg-gray-700">
            {isWhite ? (
              <Button icon={<MdOutlineLanguage className="text-white" size={20} />} />
            ) : (
              <Button icon={<MdOutlineLanguage size={20} />} variant="text" color="white" />
            )}
          </MenuButton>
        }
        transition
        align="end"
        menuClassName="select-none rounded-md p-1 text-sm dark:bg-dark-surface"
      >
        <MenuItem
          className={`mb-1 rounded-md transition-all ${
            lang === "ar"
              ? "bg-blue-400 text-white dark:bg-blue-500"
              : "hover:bg-blue-100 dark:text-white dark:hover:bg-blue-900"
          }`}
          onClick={() => changeLanguage("ar")}
        >
          {t("arabic")}
        </MenuItem>
        <MenuItem
          className={`rounded-md transition-all ${
            lang === "en"
              ? "bg-blue-400 text-white dark:bg-blue-500"
              : "hover:bg-blue-100 dark:text-white dark:hover:bg-blue-900"
          }`}
          onClick={() => changeLanguage("en")}
        >
          English
        </MenuItem>
      </Menu>
    </div>
  );
};

export default LanguageSwitcher;
